export const GET_VERIFIED_CALLER_IDS = gql`
  query VerifiedCallerIds {
    verifiedCallerIds {
      verifiedCallerIdId
      employeeId
      ownerType
      phoneNumber
      status
      validationCode
      failureReason
      verifiedAt
    }
  }
`

export const GET_MY_OUTBOUND_CALLER_ID = gql`
  query MyOutboundCallerId {
    myOutboundCallerId {
      phoneNumber
      source
    }
  }
`

export const REQUEST_CALLER_ID_VERIFICATION = gql`
  mutation RequestCallerIdVerification(
    $input: RequestCallerIdVerificationInput!
  ) {
    requestCallerIdVerification(input: $input) {
      verifiedCallerIdId
      employeeId
      ownerType
      phoneNumber
      status
      validationCode
      failureReason
      verifiedAt
    }
  }
`

export const REMOVE_VERIFIED_CALLER_ID = gql`
  mutation RemoveVerifiedCallerId($id: String!) {
    removeVerifiedCallerId(id: $id) {
      verifiedCallerIdId
    }
  }
`
